/* =====================================================================
   Wise — fiche produit : « Suite produit » (sections/wh-pdp-more.liquid)
   Équipe « Sous la fiche ». Dépend de wh-core.js (window.WH), chargé en
   defer après lui. ES5, sans module ni dépendance, idempotent : initialisé
   par WH.ready (chargement et shopify:section:load), nettoyé par WH.unload.

   1. Fonds alternés : blanc et crème recalculés quand une bande apparaît
      ou disparaît (historique vide ou effacé, recommandations sans résultat).
   2. Recommandations : API Shopify /recommendations/products en rendu de
      section (intent complementary puis related, selon le réglage), lancée
      à l'approche de la section. Les cartes du repli rendu par le serveur
      restent si l'API ne renvoie rien ou si le visiteur a déjà touché au rail.
      Ajout rapide des cartes arrivées par l'API : wise.js lie ses formulaires
      au chargement et ne les connaît donc pas. Elles passent par le formulaire
      relais [data-wh-more-proxy] (form[data-ajax-cart] lié par wise.js) :
      même ajout AJAX, même tiroir, même annonce, même vol vers le panier.
      Aucune double liaison : les cartes rendues par le serveur restent à
      wise.js seul (ce fichier ne traite que [data-wh-more-live]).
   3. Photos clients : vidéos lues sans le son seulement à l'écran ;
      visionneuse plein écran (dialog) : balayage gauche / droite et
      haut / bas (le média suit le doigt), glisser vers le bas depuis la
      première pour fermer, toucher un bord, clavier, molette, bouton Retour.
   4. Récemment consultés : rempli et effacé par wise.js (#recent-grid). Ici,
      le retrait de nos doublons si la section fiche rend aussi ces crochets,
      et après « Effacer l'historique » : annonce et focus sur la bande voisine.
   5. Une question ? : si la fiche contient le guide des tailles de wise.js
      (#size-guide), son bouton [data-guide-open] remplace le lien ; le focus
      revient sur ce bouton quand le guide se ferme.
   ===================================================================== */
(function () {
  'use strict';

  var WH = window.WH;
  if (!WH) return;

  var nav = window.navigator || {};
  var saveData = !!(nav.connection && nav.connection.saveData);
  var WISH_KEY = 'wise_wishlist';
  var HINT_KEY = 'wh-more-hint';

  /* Gestes de la visionneuse : mêmes seuils que les photos clients de l'accueil */
  var G = {
    slop: 8,        /* en deçà de 8 px, c'est un toucher */
    swipeX: 50,     /* 50 px à l'horizontale : élément suivant ou précédent */
    swipeY: 80,     /* 80 px à la verticale */
    closeY: 90,     /* 90 px vers le bas depuis le premier élément : fermer */
    flick: 0.35,    /* geste vif (px/ms) : 20 px suffisent alors */
    flickMin: 20,
    edge: 0.22,     /* toucher à moins de 22 % d'un bord : précédent / suivant */
    gap: 24,        /* écart entre deux éléments pendant le glissé */
    dur: 320,       /* alignement après un geste, une flèche, le clavier (ms) */
    tap: 240,       /* après un toucher sur un bord */
    settle: 260,    /* retour en place quand le geste ne suffit pas */
    wheel: 60,      /* molette ou pavé tactile : distance pour changer d'élément */
    wheelGap: 260   /* pause qui marque la fin d'un geste de molette */
  };

  var mqWide = media('(min-width: 750px)');
  var mqCoarse = media('(pointer: coarse)');

  /* ---------- Utilitaires ---------- */
  function media(query) {
    return window.matchMedia ? window.matchMedia(query) : null;
  }

  function isOn(list) {
    return !!(list && list.matches);
  }

  function now() {
    var perf = window.performance;
    return perf && typeof perf.now === 'function' ? perf.now() : Date.now();
  }

  function up(node, selector) {
    var el = node && node.nodeType === 3 ? node.parentNode : node;
    return el && el.nodeType === 1 && typeof el.closest === 'function' ? el.closest(selector) : null;
  }

  function play(video) {
    if (!video) return;
    try {
      video.muted = true;
      var p = video.play();
      if (p && typeof p['catch'] === 'function') p['catch'](function () {});
    } catch (err) {
      /* lecture refusée : l'image d'aperçu reste affichée */
    }
  }

  function pause(video) {
    if (!video) return;
    try {
      video.pause();
    } catch (err) {
      /* rien à faire */
    }
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      el.focus();
    }
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return (r.width > 0 || r.height > 0) && r.bottom > 0 && r.top < h;
  }

  /* Points d'un geste [{ t, x, y }] : seules les 150 dernières ms comptent */
  function addPoint(points, x, y) {
    var t = now();
    points.push({ t: t, x: x, y: y });
    while (points.length > 2 && t - points[0].t > 150) points.shift();
  }

  /* Vitesse (px/ms) sur les 100 dernières ms ; 0 si le doigt s'est arrêté avant de se lever */
  function speed(points, axis) {
    if (!points.length) return 0;
    var last = points[points.length - 1];
    var first = last;
    for (var i = points.length - 2; i >= 0; i--) {
      if (last.t - points[i].t > 100) break;
      first = points[i];
    }
    var dt = last.t - first.t;
    if (dt < 10) return 0;
    return (axis === 'y' ? last.y - first.y : last.x - first.x) / dt;
  }

  /* Écouteur retiré au nettoyage de la section */
  function listen(st, el, type, fn, opts) {
    if (!el) return;
    var o = opts || false;
    el.addEventListener(type, fn, o);
    st.offs.push(function () {
      el.removeEventListener(type, fn, o);
    });
  }

  /* ---------- Initialisation ---------- */
  function init(root) {
    if (root.__whMore) return;
    var st = { root: root, offs: [], hinted: false };
    root.__whMore = st;
    initRecent(st);
    initBands(st);
    initRecos(st);
    initUgc(st);
    initHelp(st);
  }

  function destroy(root) {
    var st = root.__whMore;
    if (!st) return;
    root.__whMore = null;
    for (var i = st.offs.length - 1; i >= 0; i--) {
      try {
        st.offs[i]();
      } catch (err) {
        if (window.console && typeof window.console.error === 'function') window.console.error('[WH more]', err);
      }
    }
    st.offs = [];
  }

  /* ---------- 1. Fonds alternés ---------- */
  function initBands(st) {
    var root = st.root;
    var first = root.getAttribute('data-wh-more-first') === 'white' ? 'white' : 'cream';
    var second = first === 'white' ? 'cream' : 'white';
    var bands = WH.all('[data-wh-more-band]', root);
    if (!bands.length) return;

    function paint() {
      var n = 0;
      for (var i = 0; i < bands.length; i++) {
        var band = bands[i];
        if (band.hidden) continue;
        var scheme = n % 2 === 0 ? first : second;
        n++;
        band.classList.toggle('wh--cream', scheme === 'cream');
        band.classList.toggle('wh--white', scheme === 'white');
      }
    }

    paint();
    if (typeof window.MutationObserver === 'function') {
      var mo = new window.MutationObserver(paint);
      for (var i = 0; i < bands.length; i++) mo.observe(bands[i], { attributes: true, attributeFilter: ['hidden'] });
      st.offs.push(function () {
        mo.disconnect();
      });
    }
  }

  /* ---------- 2. Recommandations ---------- */
  function initRecos(st) {
    var root = st.root;
    var bands = WH.all('[data-wh-more-reco]', root);
    if (!bands.length) return;
    var relay = makeRelay(root.querySelector('[data-wh-more-proxy]'));

    for (var i = 0; i < bands.length; i++) setupReco(st, bands[i]);

    /* Cartes arrivées par l'API uniquement ([data-wh-more-live]) : wise.js gère les autres */
    listen(st, root, 'click', function (e) {
      onLiveClick(st, e, relay);
    });
    listen(st, root, 'submit', function (e) {
      onLiveSubmit(e, relay);
    });
    listen(st, document, 'click', function (e) {
      if (!up(e.target, '[data-wh-more-live] [data-card-quick]')) closePanels(root, null);
    });
    listen(st, document, 'keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closePanels(root, null);
    });
  }

  function setupReco(st, band) {
    var base = band.getAttribute('data-wh-more-url');
    var mode = band.getAttribute('data-wh-more-intent') || 'related';
    var limit = parseInt(band.getAttribute('data-wh-more-limit'), 10) || 8;
    var track = band.querySelector('[data-wh-more-reco-list]');
    if (!base || !track || typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function') return;
    var alive = true;
    var started = false;

    st.offs.push(function () {
      alive = false;
    });

    function get(intent) {
      return window.fetch(base + '&intent=' + intent, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Recommandations : HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new window.DOMParser().parseFromString(html, 'text/html');
          var box = doc.querySelector('[data-wh-more-reco-result]');
          return box ? WH.all('[data-wh-more-reco-item]', box) : [];
        });
    }

    function run() {
      if (started) return;
      started = true;
      var firstIntent = mode === 'related' ? 'related' : 'complementary';
      get(firstIntent).then(function (items) {
        if (!alive) return null;
        if (mode === 'auto') {
          /* « Complétez le look » seulement avec au moins deux vraies pièces complémentaires */
          if (items.length >= 2) {
            apply(items, 'comp');
            return null;
          }
          return get('related').then(function (rel) {
            if (alive) apply(rel, 'rel');
          });
        }
        apply(items, mode === 'complementary' ? 'comp' : 'rel');
        return null;
      })['catch'](function () {
        /* réseau, section introuvable (aperçu d'un autre thème) : le repli rendu par le serveur reste */
      });
    }

    /* Le visiteur a déjà fait défiler le rail, ouvert un choix de taille ou posé le focus dedans */
    function touched() {
      if (Math.abs(track.scrollLeft) > 4) return true;
      var active = document.activeElement;
      if (active && active !== document.body && band.contains(active)) return true;
      return !!band.querySelector('[data-quick-panel]:not([hidden])');
    }

    function setTitle(kind) {
      var rel = band.querySelector('[data-wh-more-t="rel"]');
      var comp = band.querySelector('[data-wh-more-t="comp"]');
      if (rel && comp) {
        rel.hidden = kind === 'comp';
        comp.hidden = kind !== 'comp';
      }
      var shown = kind === 'comp' ? (comp || rel) : (rel || comp);
      var text = shown ? String(shown.textContent || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '') : '';
      if (text) track.setAttribute('aria-label', text + ', faites défiler');
      /* Le lien « Tout voir » mène à la collection de repli : hors sujet sous « Complétez le look » */
      var link = band.querySelector('.wh-head__aside .wh-link');
      if (link && mode === 'auto') link.hidden = kind === 'comp';
    }

    function syncWish() {
      var list = WH.storage.get(WISH_KEY, []);
      var set = {};
      if (list && list.length) {
        for (var i = 0; i < list.length; i++) {
          if (list[i] && list[i].handle) set[list[i].handle] = true;
        }
      }
      WH.all('[data-wh-more-live] [data-wish]', track).forEach(function (btn) {
        var active = !!set[btn.getAttribute('data-handle')];
        btn.classList.toggle('is-active', active);
        var off = btn.querySelector('.wish-off');
        var on = btn.querySelector('.wish-on');
        if (off) off.hidden = active;
        if (on) on.hidden = !active;
      });
    }

    function swap(items, kind) {
      if (!alive) return;
      var seen = {};
      var count = 0;
      var frag = document.createDocumentFragment();
      var end = track.querySelector('[data-wh-more-end]');

      function take(li, live) {
        var handle = li.getAttribute('data-handle');
        if (count >= limit || !handle || seen[handle]) return;
        seen[handle] = true;
        if (live) li.setAttribute('data-wh-more-live', '');
        frag.appendChild(li);
        count++;
      }

      for (var i = 0; i < items.length; i++) take(document.importNode(items[i], true), true);
      /* Pièces similaires : la liste se complète avec le repli (nœuds gardés : wise.js les a déjà liés) */
      if (kind === 'rel') {
        var ssr = WH.all('[data-wh-more-reco-item]', track);
        for (var j = 0; j < ssr.length; j++) take(ssr[j], false);
      }
      if (end && !(kind === 'comp' && mode === 'auto')) frag.appendChild(end);

      while (track.firstChild) track.removeChild(track.firstChild);
      track.appendChild(frag);
      /* Nombre de cartes : la grille d'ordinateur masque une dernière rangée incomplète (CSS §3) */
      track.setAttribute('data-wh-more-n', String(count));
      track.scrollLeft = 0;
      setTitle(kind);
      syncWish();
      if (band.hidden) band.hidden = false;
      var scroller = band.querySelector('[data-wh-scroller]');
      if (scroller && scroller.__whScroller) scroller.__whScroller.update();
      track.classList.remove('is-swapping');
      if (typeof window.CustomEvent === 'function') {
        band.dispatchEvent(new window.CustomEvent('wh:more:reco', { bubbles: true, detail: { kind: kind, count: count } }));
      }
    }

    function apply(items, kind) {
      if (!alive || !band.isConnected || !items.length) return;
      if (touched()) return;
      if (!WH.reduced && !band.hidden && inViewport(track)) {
        /* sous les yeux du visiteur : fondu court, abandonné s'il touche au rail entre-temps */
        track.classList.add('is-swapping');
        window.setTimeout(function () {
          if (touched()) {
            track.classList.remove('is-swapping');
            return;
          }
          swap(items, kind);
        }, 200);
      } else {
        swap(items, kind);
      }
    }

    /* Lancé à l'approche de la section (1200 px), une seule fois */
    st.offs.push(WH.inView(st.root, run, null, { rootMargin: '1200px 0px 1200px 0px', threshold: 0, once: true }));
  }

  /* Relais d'ajout au panier : form[data-ajax-cart] rendu avec la section, donc lié par wise.js.
     wise.js désactive son bouton pendant l'envoi, pose .is-added s'il a réussi, puis le réactive :
     c'est ce signal qui termine l'ajout ici (en cas d'échec, wise.js ouvre la page panier). */
  function makeRelay(form) {
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var btn = form ? form.querySelector('[type="submit"]') : null;
    var ready = !!(form && idInput && btn);
    var busy = false;

    function send() {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }
      var ev;
      try {
        ev = new window.Event('submit', { bubbles: true, cancelable: true });
      } catch (err) {
        ev = document.createEvent('Event');
        ev.initEvent('submit', true, true);
      }
      /* personne n'a intercepté l'envoi : envoi classique (ajout puis page panier) */
      if (form.dispatchEvent(ev)) form.submit();
    }

    function add(id, ui) {
      if (!ready || busy || !id) return false;
      busy = true;
      idInput.value = String(id);
      if (qtyInput) qtyInput.value = '1';
      btn.classList.remove('is-added');
      var el = ui && ui.el;
      if (el) {
        el.disabled = true;
        el.classList.add('is-loading');
        el.setAttribute('aria-busy', 'true');
      }
      var done = false;
      var mo = null;
      var timer = 0;

      function finish() {
        if (done) return;
        done = true;
        if (mo) mo.disconnect();
        window.clearTimeout(timer);
        busy = false;
        var success = btn.classList.contains('is-added');
        if (el) {
          el.disabled = false;
          el.classList.remove('is-loading');
          el.removeAttribute('aria-busy');
        }
        if (ui && typeof ui.done === 'function') ui.done(success);
      }

      if (typeof window.MutationObserver === 'function') {
        mo = new window.MutationObserver(function () {
          if (!btn.disabled) finish();
        });
        mo.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      }
      timer = window.setTimeout(finish, 15000);
      try {
        send();
      } catch (err) {
        finish();
      }
      return true;
    }

    return { ready: ready, add: add };
  }

  /* Ajout direct sans relais (repli) : lien d'ajout Shopify, puis page panier */
  function cartAddUrl(id) {
    var routes = window.WiseRoutes || {};
    return (routes.cartAdd || '/cart/add') + '?id=' + encodeURIComponent(id) + '&quantity=1';
  }

  /* Même retour visuel que wise.js : « Ajouté au panier » sur fond vert, puis le libellé revient */
  function flash(btn) {
    if (!btn) return;
    if (btn.__whMoreLabel == null) btn.__whMoreLabel = btn.innerHTML;
    window.clearTimeout(btn.__whMoreTimer);
    btn.classList.add('is-added');
    btn.textContent = 'Ajouté au panier';
    btn.__whMoreTimer = window.setTimeout(function () {
      btn.classList.remove('is-added');
      btn.innerHTML = btn.__whMoreLabel;
      btn.__whMoreLabel = null;
    }, 1800);
  }

  /* Annonce aux lecteurs d'écran, dans la région du layout utilisée par wise.js (#live-region).
     addToCart de wise.js annonce déjà l'ajout ; on reproduit seulement l'annonce supplémentaire
     du choix de taille (wise.js fait de même pour ses propres cartes), et « Historique effacé ». */
  function announce(message) {
    var region = document.getElementById('live-region');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 60);
  }

  function fly(card) {
    if (!card || typeof window.wiseFlyToCart !== 'function') return;
    try {
      window.wiseFlyToCart(card.querySelector('.card__img img') || card);
    } catch (err) {
      /* animation facultative */
    }
  }

  /* Ferme les choix de taille ouverts : ceux des cartes de l'API (live), ou tous avec all = true.
     wise.js ne garde aucun état à part l'attribut hidden et aria-expanded : on pose les mêmes. */
  function closePanels(root, except, all) {
    WH.all(all ? '[data-card-quick]' : '[data-wh-more-live] [data-card-quick]', root).forEach(function (quick) {
      if (quick === except) return;
      var panel = quick.querySelector('[data-quick-panel]');
      var opener = quick.querySelector('[data-quick-open]');
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      if (opener) opener.setAttribute('aria-expanded', 'false');
    });
  }

  /* Choix de la taille dans une carte arrivée par l'API (même comportement que wise.js) */
  function onLiveClick(st, e, relay) {
    var live = up(e.target, '[data-wh-more-live]');
    if (!live) return;
    var quick = up(e.target, '[data-card-quick]');
    if (!quick || !live.contains(quick)) return;
    var opener = quick.querySelector('[data-quick-open]');
    var panel = quick.querySelector('[data-quick-panel]');
    if (!opener || !panel) return;

    if (up(e.target, '[data-quick-open]')) {
      var willOpen = panel.hidden;
      closePanels(st.root, quick, true);
      panel.hidden = !willOpen;
      opener.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    if (up(e.target, '[data-quick-close]')) {
      panel.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      focusEl(opener);
      return;
    }

    var size = up(e.target, '[data-quick-variant]');
    if (!size || size.disabled) return;
    var id = parseInt(size.getAttribute('data-quick-variant'), 10);
    if (!id) return;
    var card = up(quick, '.card');
    if (!relay.ready) {
      window.location.href = cartAddUrl(id);
      return;
    }
    relay.add(id, {
      el: size,
      done: function (ok) {
        panel.hidden = true;
        opener.setAttribute('aria-expanded', 'false');
        if (ok) {
          fly(card);
          flash(opener);
          announce('Article ajouté au panier');
        }
      }
    });
  }

  /* Pièce sans taille dans une carte arrivée par l'API : son formulaire passe par le relais */
  function onLiveSubmit(e, relay) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM' || form.hasAttribute('data-wh-more-proxy')) return;
    if (!relay.ready || !up(form, '[data-wh-more-live]')) return;
    var idEl = form.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var card = up(form, '.card');
    relay.add(idEl.value, {
      el: btn,
      done: function (ok) {
        /* pas d'annonce ici : addToCart de wise.js a déjà dit « Produit ajouté au panier » */
        if (ok) {
          fly(card);
          flash(btn);
        }
      }
    });
  }

  /* ---------- 3. Photos clients ---------- */
  function initUgc(st) {
    WH.all('[data-wh-more-ugc]', st.root).forEach(function (band) {
      var videos = autoplay(st, band);
      var dialog = band.querySelector('[data-wh-more-viewer]');
      var openers = WH.all('[data-wh-more-open]', band);
      if (!dialog || !openers.length) return;
      var viewer = createViewer(st, band, dialog, videos);
      if (!viewer) return;
      openers.forEach(function (btn) {
        listen(st, btn, 'click', function (e) {
          e.preventDefault();
          viewer.open(parseInt(btn.getAttribute('data-wh-more-open'), 10) || 0, btn);
        });
      });
    });
  }

  /* Vidéos du bandeau : sans le son, en boucle, seulement à l'écran (60 % visibles) */
  function autoplay(st, band) {
    var allowed = band.hasAttribute('data-wh-more-autoplay') && !saveData;
    var vids = WH.all('video[data-wh-more-vid]', band);
    var api = {
      hold: false,
      pauseAll: function () {
        vids.forEach(pause);
      },
      resume: function () {
        vids.forEach(function (v) {
          if (v.__whMoreIn) start(v);
        });
      }
    };

    function start(v) {
      if (!allowed || WH.reduced || api.hold || document.hidden) return;
      if (!v.getAttribute('src')) {
        var src = v.getAttribute('data-src');
        if (!src) return;
        v.setAttribute('src', src);
      }
      play(v);
    }

    vids.forEach(function (v) {
      var tile = up(v, '[data-wh-more-open]') || v.parentNode;
      listen(st, v, 'playing', function () {
        tile.classList.add('is-playing');
      });
      listen(st, v, 'pause', function () {
        tile.classList.remove('is-playing');
      });
      st.offs.push(WH.inView(tile, function () {
        v.__whMoreIn = true;
        start(v);
      }, function () {
        v.__whMoreIn = false;
        pause(v);
      }, { threshold: 0.6 }));
    });

    if (vids.length) {
      listen(st, document, 'visibilitychange', function () {
        if (document.hidden) api.pauseAll();
        else api.resume();
      });
      st.offs.push(WH.onReduced(function (reduced) {
        if (reduced) api.pauseAll();
        else api.resume();
      }));
      st.offs.push(api.pauseAll);
    }
    return api;
  }

  /* Visionneuse : trois diapositives au plus dans la page (précédente, courante, suivante),
     créées depuis le modèle <template> de chaque tuile. Photos et vidéos forment un seul flux. */
  function createViewer(st, band, dialog, videos) {
    var items = WH.all('[data-wh-more-item]', band);
    var total = items.length;
    var body = dialog.querySelector('[data-wh-more-vw-body]');
    var stage = dialog.querySelector('[data-wh-more-vw-stage]');
    if (!total || !body || !stage) return null;
    var numEl = dialog.querySelector('[data-wh-more-vw-num]');
    var srEl = dialog.querySelector('[data-wh-more-vw-sr]');
    var btnPrev = dialog.querySelector('[data-wh-more-vw-prev]');
    var btnNext = dialog.querySelector('[data-wh-more-vw-next]');
    var btnClose = dialog.querySelector('[data-wh-more-vw-close]');
    var hint = dialog.querySelector('[data-wh-more-vw-hint]');
    var modal = typeof dialog.showModal === 'function';

    var isOpen = false;
    var closing = false;
    var cur = 0;
    var opener = null;
    var slides = {};
    var gest = null;
    var anim = 0;
    var animEnd = null;
    var suppressUntil = 0;
    var wheel = { x: 0, y: 0, last: 0, done: false };
    var lockState = null;
    var pushed = false;
    var skipPop = false;
    var hintTimer = 0;

    /* ----- Diapositives ----- */
    function slide(i) {
      if (i < 0 || i >= total) return null;
      if (slides[i]) return slides[i];
      var tpl = items[i].querySelector('template[data-wh-more-slide]');
      var src = tpl && tpl.content ? tpl.content.firstElementChild : null;
      if (!src) return null;
      var el = document.importNode(src, true);
      el.setAttribute('aria-label', (i + 1) + ' sur ' + total);
      el.setAttribute('aria-hidden', 'true');
      el.style.visibility = 'hidden';
      var v = el.querySelector('video');
      if (v) {
        el.classList.add('is-paused');
        v.addEventListener('play', function () {
          el.classList.remove('is-paused');
        });
        v.addEventListener('pause', function () {
          el.classList.add('is-paused');
        });
      }
      stage.appendChild(el);
      slides[i] = el;
      return el;
    }

    function videoOf(el) {
      return el ? el.querySelector('video') : null;
    }

    function size(axis) {
      var s = axis === 'y' ? stage.clientHeight : stage.clientWidth;
      return (s || (axis === 'y' ? window.innerHeight : window.innerWidth)) + G.gap;
    }

    function place(el, axis, off, scale) {
      if (!el) return;
      var t = axis === 'y' ? 'translate3d(0,' + off + 'px,0)' : 'translate3d(' + off + 'px,0,0)';
      if (scale && scale !== 1) t += ' scale(' + scale.toFixed(4) + ')';
      el.style.transform = t;
      el.style.visibility = 'visible';
    }

    function park(el) {
      if (!el) return;
      el.style.transform = '';
      el.style.visibility = 'hidden';
    }

    function fade(f) {
      if (f >= 1) body.style.removeProperty('--wh-more-fade');
      else body.style.setProperty('--wh-more-fade', Math.max(0, f).toFixed(3));
    }

    /* Courante au centre, voisines prêtes mais cachées, les autres retirées de la page */
    function layout() {
      slide(cur - 1);
      slide(cur);
      slide(cur + 1);
      Object.keys(slides).forEach(function (key) {
        var i = parseInt(key, 10);
        var el = slides[key];
        if (Math.abs(i - cur) > 1) {
          pause(videoOf(el));
          if (el.parentNode) el.parentNode.removeChild(el);
          delete slides[key];
          return;
        }
        if (i === cur) {
          el.style.transform = '';
          el.style.visibility = 'visible';
          el.removeAttribute('aria-hidden');
          el.classList.add('is-current');
        } else {
          park(el);
          el.setAttribute('aria-hidden', 'true');
          el.classList.remove('is-current');
          pause(videoOf(el));
        }
      });
      fade(1);
    }

    function sync() {
      if (numEl) numEl.textContent = (cur + 1) + ' / ' + total;
      if (srEl) srEl.textContent = 'Élément ' + (cur + 1) + ' sur ' + total;
      if (btnPrev) btnPrev.setAttribute('aria-disabled', cur <= 0 ? 'true' : 'false');
      if (btnNext) btnNext.setAttribute('aria-disabled', cur >= total - 1 ? 'true' : 'false');
    }

    function playCurrent() {
      var el = slides[cur];
      var v = videoOf(el);
      if (!v) return;
      if (WH.reduced || saveData) {
        el.classList.add('is-paused');
        return;
      }
      play(v);
    }

    function setCurrent(i) {
      pause(videoOf(slides[cur]));
      cur = i;
      layout();
      sync();
      playCurrent();
    }

    /* ----- Animations ----- */
    function finishAnim() {
      if (!anim) return;
      window.clearTimeout(anim);
      anim = 0;
      stage.classList.remove('is-anim');
      var cb = animEnd;
      animEnd = null;
      if (cb) cb();
    }

    function animate(ms, apply, done) {
      finishAnim();
      var dur = WH.reduced ? 0 : ms;
      if (!dur) {
        apply();
        if (done) done();
        return;
      }
      stage.style.setProperty('--wh-more-dur', dur + 'ms');
      stage.classList.add('is-anim');
      void stage.offsetWidth; /* la transition s'applique avant le déplacement */
      apply();
      animEnd = done || null;
      anim = window.setTimeout(function () {
        anim = 0;
        stage.classList.remove('is-anim');
        var cb = animEnd;
        animEnd = null;
        if (cb) cb();
      }, dur + 40);
    }

    function go(target, axis, ms) {
      if (!isOpen || closing) return;
      finishAnim(); /* une animation en cours se termine d'abord (sa diapositive devient la courante) */
      var ax = axis === 'y' ? 'y' : 'x';
      if (target < 0 || target >= total || target === cur) {
        settle(ax);
        return;
      }
      var dir = target > cur ? 1 : -1;
      var from = slides[cur];
      var to = slide(target);
      if (!to) return;
      var sz = size(ax);
      if (to.style.visibility !== 'visible') {
        /* placée hors champ sans transition, puis amenée au centre */
        place(to, ax, dir * sz);
        void to.offsetWidth;
      }
      to.removeAttribute('aria-hidden');
      animate(ms || G.dur, function () {
        place(from, ax, -dir * sz);
        place(to, ax, 0);
        fade(1);
      }, function () {
        setCurrent(target);
      });
    }

    function step(delta, axis, ms) {
      finishAnim();
      go(cur + delta, axis, ms);
    }

    /* Geste insuffisant : tout revient en place */
    function settle(axis) {
      var ax = axis === 'y' ? 'y' : 'x';
      var sz = size(ax);
      var prev = slides[cur - 1];
      var next = slides[cur + 1];
      animate(G.settle, function () {
        place(slides[cur], ax, 0);
        if (prev && prev.style.visibility === 'visible') place(prev, ax, -sz);
        if (next && next.style.visibility === 'visible') place(next, ax, sz);
        fade(1);
      }, layout);
    }

    /* Fermeture par le geste : le média part dans le sens du doigt, le fond s'efface */
    function dismiss(axis, sign) {
      if (!isOpen || closing) return;
      closing = true;
      hideHint();
      animate(240, function () {
        place(slides[cur], axis, sign * size(axis) * 0.5, 0.9);
        fade(0);
      }, function () {
        finish(false);
      });
    }

    /* ----- Gestes (pointeur : doigt, souris, stylet) ----- */
    function interactive(t) {
      return !!up(t, 'a, button, input, select, textarea, label, summary, [role="button"]');
    }

    function rubber(d, sz) {
      var r = sz * (1 - 1 / (Math.abs(d) * 0.55 / sz + 1));
      return d < 0 ? -r : r;
    }

    function onDown(e) {
      if (!isOpen || closing) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (interactive(e.target)) return;
      if (gest) {
        var same = e.pointerId === gest.id;
        cancelGesture();
        if (!same) return; /* un deuxième doigt annule le geste en cours */
      }
      finishAnim();
      hideHint();
      gest = { id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: 0, dy: 0, axis: '', mode: '', sz: 0, pts: [], target: e.target };
      addPoint(gest.pts, e.clientX, e.clientY);
    }

    function onMove(e) {
      var g = gest;
      if (!g || e.pointerId !== g.id) return;
      g.dx = e.clientX - g.x0;
      g.dy = e.clientY - g.y0;
      addPoint(g.pts, e.clientX, e.clientY);
      if (!g.axis) {
        if (Math.abs(g.dx) <= G.slop && Math.abs(g.dy) <= G.slop) return;
        g.axis = Math.abs(g.dx) > Math.abs(g.dy) ? 'x' : 'y'; /* l'axe est fixé pour tout le geste */
        g.sz = size(g.axis);
        body.classList.add('is-dragging');
        try {
          body.setPointerCapture(g.id);
        } catch (err) {
          /* capture indisponible : le geste reste suivi dans la visionneuse */
        }
      }
      drag(g);
    }

    /* Le média suit le doigt ; la voisine vers laquelle on va arrive avec lui */
    function drag(g) {
      var d = g.axis === 'x' ? g.dx : g.dy;
      var forward = d < 0; /* vers la gauche ou vers le haut : élément suivant */
      var target = forward ? cur + 1 : cur - 1;
      var off = d;
      var scale = 1;
      var f = 1;
      var prev = slides[cur - 1];
      var next = slides[cur + 1];
      if (!forward && g.axis === 'y' && cur === 0) {
        g.mode = 'close';
        off = Math.min(d, 420);
        scale = 1 - off / 2400;
        f = 1 - off / 600;
      } else if (target < 0 || target >= total) {
        g.mode = 'edge';
        off = rubber(d, g.sz);
      } else {
        g.mode = 'nav';
      }
      place(slides[cur], g.axis, off, scale);
      if (g.mode === 'nav' && forward) {
        place(next, g.axis, off + g.sz);
        park(prev);
      } else if (g.mode === 'nav') {
        place(prev, g.axis, off - g.sz);
        park(next);
      } else {
        park(prev);
        park(next);
      }
      fade(f);
    }

    function onUp(e) {
      var g = gest;
      if (!g || e.pointerId !== g.id) return;
      gest = null;
      var cancelled = e.type === 'pointercancel';
      if (!g.axis) {
        if (!cancelled) tap(e, g);
        return;
      }
      try {
        body.releasePointerCapture(g.id);
      } catch (err) {
        /* déjà relâchée */
      }
      body.classList.remove('is-dragging');
      suppressUntil = now() + 400; /* le clic qui suit un glissé ne déclenche rien */
      if (cancelled) {
        settle(g.axis);
        return;
      }
      g.dx = e.clientX - g.x0;
      g.dy = e.clientY - g.y0;
      addPoint(g.pts, e.clientX, e.clientY);
      drag(g);
      release(g);
    }

    /* Fin du glissé : distance parcourue ou geste vif */
    function release(g) {
      var d = g.axis === 'x' ? g.dx : g.dy;
      var v = speed(g.pts, g.axis);
      var ad = Math.abs(d);
      var av = Math.abs(v);
      var thr = g.axis === 'x' ? G.swipeX : (g.mode === 'close' ? G.closeY : G.swipeY);
      var back = av >= G.flick && (v < 0) !== (d < 0); /* relancé dans l'autre sens : on annule */
      var pass = !back && (ad >= thr || (av >= G.flick && ad >= G.flickMin));
      if (!pass || g.mode === 'edge' || !g.mode) {
        settle(g.axis);
        return;
      }
      if (g.mode === 'close') {
        dismiss(g.axis, d < 0 ? -1 : 1);
        return;
      }
      go(d < 0 ? cur + 1 : cur - 1, g.axis, av > 0.9 ? 220 : (av > 0.5 ? 260 : G.dur));
    }

    function cancelGesture() {
      var g = gest;
      gest = null;
      if (!g || !g.axis) return;
      try {
        body.releasePointerCapture(g.id);
      } catch (err) {
        /* déjà relâchée */
      }
      body.classList.remove('is-dragging');
      suppressUntil = now() + 400;
      settle(g.axis);
    }

    /* Toucher : bords = précédent / suivant, centre d'une vidéo = pause ou lecture ;
       sur un grand écran, un clic à côté du média ferme */
    function tap(e, g) {
      var t = g.target;
      if (up(t, '.wh-more__slide-info, .wh-more__vw-top')) return;
      var mediaEl = up(t, '.wh-more__slide-media');
      var x;
      if (isOn(mqWide)) {
        if (!mediaEl) {
          close();
          return;
        }
        var r = mediaEl.getBoundingClientRect();
        x = r.width ? (e.clientX - r.left) / r.width : 0.5;
      } else {
        x = e.clientX / (window.innerWidth || 1);
      }
      if (x < G.edge) step(-1, 'x', G.tap);
      else if (x > 1 - G.edge) step(1, 'x', G.tap);
      else togglePlay();
    }

    function togglePlay() {
      var v = videoOf(slides[cur]);
      if (!v) return;
      if (v.paused) play(v);
      else pause(v);
    }

    /* Molette ou pavé tactile : un élément par geste */
    function onWheel(e) {
      if (!isOpen || e.ctrlKey) return;
      e.preventDefault();
      if (closing || gest) return;
      var t = now();
      if (t - wheel.last > G.wheelGap) {
        wheel.x = 0;
        wheel.y = 0;
        wheel.done = false;
      }
      wheel.last = t;
      if (wheel.done) return;
      var unit = e.deltaMode === 1 ? 16 : (e.deltaMode === 2 ? (stage.clientHeight || 600) : 1);
      wheel.x += e.deltaX * unit;
      wheel.y += e.deltaY * unit;
      if (Math.abs(wheel.y) >= G.wheel && Math.abs(wheel.y) >= Math.abs(wheel.x)) {
        wheel.done = true;
        step(wheel.y > 0 ? 1 : -1, 'y');
      } else if (Math.abs(wheel.x) >= G.wheel) {
        wheel.done = true;
        step(wheel.x > 0 ? 1 : -1, 'x');
      }
    }

    function onKey(e) {
      if (!isOpen || closing) return;
      var k = e.key;
      if (k === 'Escape' || k === 'Esc') {
        /* aussi sans dialog natif (repli [open]) ; avec showModal, l'événement cancel ne part plus */
        e.preventDefault();
        close();
      } else if (k === 'ArrowRight' || k === 'Right') {
        e.preventDefault();
        step(1, 'x');
      } else if (k === 'ArrowLeft' || k === 'Left') {
        e.preventDefault();
        step(-1, 'x');
      } else if (k === 'ArrowDown' || k === 'Down' || k === 'PageDown') {
        e.preventDefault();
        step(1, 'y');
      } else if (k === 'ArrowUp' || k === 'Up' || k === 'PageUp') {
        e.preventDefault();
        step(-1, 'y');
      } else if (k === 'Home') {
        e.preventDefault();
        finishAnim();
        go(0, 'x');
      } else if (k === 'End') {
        e.preventDefault();
        finishAnim();
        go(total - 1, 'x');
      } else if ((k === ' ' || k === 'Spacebar') && !up(e.target, 'a, button')) {
        e.preventDefault();
        togglePlay();
      }
    }

    function onClickCapture(e) {
      if (suppressUntil && now() < suppressUntil) {
        e.preventDefault();
        e.stopPropagation();
      }
      suppressUntil = 0;
    }

    /* Filet de sécurité (iOS) : la page derrière ne défile jamais */
    function onTouchMove(e) {
      if (isOpen && e.cancelable) e.preventDefault();
    }

    /* ----- Ouverture et fermeture ----- */
    function lock() {
      var de = document.documentElement;
      var b = document.body;
      var sbw = window.innerWidth - de.clientWidth;
      lockState = { html: de.style.overflow, body: b.style.overflow, pad: b.style.paddingRight };
      de.style.overflow = 'hidden';
      b.style.overflow = 'hidden';
      if (sbw > 0) b.style.paddingRight = sbw + 'px'; /* pas de saut quand la barre de défilement disparaît */
    }

    function unlock() {
      if (!lockState) return;
      var de = document.documentElement;
      var b = document.body;
      de.style.overflow = lockState.html;
      b.style.overflow = lockState.body;
      b.style.paddingRight = lockState.pad;
      lockState = null;
    }

    /* Une fois par session, au doigt : « Balayez pour voir la suite » (déjà vu sur l'accueil : rien) */
    function maybeHint() {
      if (!hint || total < 2 || !isOn(mqCoarse) || st.hinted) return;
      st.hinted = true;
      try {
        var store = window.sessionStorage;
        if (store.getItem(HINT_KEY) === '1' || store.getItem('wh-ugc-hint') === '1') return;
        store.setItem(HINT_KEY, '1');
      } catch (err) {
        /* stockage indisponible : l'indication s'affiche une fois par page */
      }
      hint.hidden = false;
      void hint.offsetWidth;
      hint.classList.add('is-on');
      hintTimer = window.setTimeout(hideHint, 3200);
    }

    function hideHint() {
      window.clearTimeout(hintTimer);
      hintTimer = 0;
      if (!hint) return;
      hint.classList.remove('is-on');
      hint.hidden = true;
    }

    function open(index, from) {
      if (isOpen || !total) return;
      isOpen = true;
      closing = false;
      skipPop = false;
      opener = from || null;
      cur = Math.max(0, Math.min(total - 1, index || 0));
      if (videos) {
        videos.hold = true;
        videos.pauseAll();
      }
      lock();
      dialog.classList.remove('is-closing');
      if (modal) {
        try {
          dialog.showModal();
        } catch (err) {
          dialog.setAttribute('open', '');
        }
      } else {
        dialog.setAttribute('open', '');
      }
      dialog.classList.add('is-open');
      layout();
      sync();
      playCurrent();
      /* Bouton Retour du téléphone : ferme la visionneuse au lieu de quitter la fiche */
      if (!WH.design && window.history && typeof window.history.pushState === 'function') {
        try {
          window.history.pushState({ whMoreViewer: true }, '');
          pushed = true;
        } catch (err) {
          pushed = false;
        }
      }
      focusEl(btnClose);
      maybeHint();
    }

    function close() {
      if (!isOpen || closing) return;
      closing = true;
      hideHint();
      gest = null;
      dialog.classList.remove('is-open');
      dialog.classList.add('is-closing');
      window.setTimeout(function () {
        finish(false);
      }, WH.reduced ? 0 : 200);
    }

    /* native : le navigateur a déjà fermé le dialog (événement close) */
    function finish(native) {
      if (!isOpen) return;
      isOpen = false;
      closing = false;
      gest = null;
      if (anim) {
        window.clearTimeout(anim);
        anim = 0;
        animEnd = null;
        stage.classList.remove('is-anim');
      }
      Object.keys(slides).forEach(function (key) {
        var el = slides[key];
        pause(videoOf(el));
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      slides = {};
      body.classList.remove('is-dragging');
      fade(1);
      if (!native) {
        if (dialog.open && typeof dialog.close === 'function') {
          try {
            dialog.close();
          } catch (err) {
            dialog.removeAttribute('open');
          }
        } else {
          dialog.removeAttribute('open');
        }
      }
      dialog.classList.remove('is-open');
      dialog.classList.remove('is-closing');
      unlock();
      if (videos) {
        videos.hold = false;
        videos.resume();
      }
      if (pushed) {
        pushed = false;
        skipPop = true;
        try {
          window.history.back();
        } catch (err) {
          skipPop = false;
        }
      }
      var back = opener;
      opener = null;
      if (back && back.isConnected) focusEl(back);
    }

    function onPop() {
      if (skipPop) {
        skipPop = false;
        return;
      }
      if (isOpen) {
        pushed = false; /* l'entrée d'historique est déjà retirée */
        close();
      }
    }

    function onCancel(e) {
      e.preventDefault();
      close();
    }

    function onNativeClose() {
      if (isOpen) finish(true);
    }

    listen(st, body, 'pointerdown', onDown, { passive: true });
    listen(st, body, 'pointermove', onMove, { passive: true });
    listen(st, body, 'pointerup', onUp, { passive: true });
    listen(st, body, 'pointercancel', onUp, { passive: true });
    listen(st, dialog, 'click', onClickCapture, true);
    listen(st, dialog, 'wheel', onWheel, { passive: false });
    listen(st, dialog, 'touchmove', onTouchMove, { passive: false });
    /* sur document : après un clic sur une zone sans focus, les touches partent du body */
    listen(st, document, 'keydown', onKey);
    listen(st, dialog, 'cancel', onCancel);
    listen(st, dialog, 'close', onNativeClose);
    listen(st, dialog, 'dragstart', function (e) {
      e.preventDefault();
    });
    listen(st, window, 'popstate', onPop);
    listen(st, btnClose, 'click', close);
    listen(st, btnPrev, 'click', function () {
      if (btnPrev.getAttribute('aria-disabled') !== 'true') step(-1, 'x');
    });
    listen(st, btnNext, 'click', function () {
      if (btnNext.getAttribute('aria-disabled') !== 'true') step(1, 'x');
    });
    st.offs.push(function () {
      hideHint();
      if (isOpen) finish(false);
    });

    return { open: open, close: close };
  }

  /* ---------- 4. Récemment consultés ---------- */
  /* wise.js (chargé avant ce fichier) a déjà lu le premier #recent-current de la page et rempli le
     premier #recent-grid. Si la section fiche rend aussi ces crochets (son réglage « Afficher les
     pièces récemment consultées »), nos doublons perdent leur id et notre bande reste masquée. */
  function initRecent(st) {
    var root = st.root;
    var current = root.querySelector('[data-wh-more-current]');
    if (current) {
      var currents = document.querySelectorAll('[id="recent-current"]');
      if (currents.length > 1 && currents[0] !== current) current.removeAttribute('id');
    }
    var band = root.querySelector('[data-wh-more-recent]');
    if (!band) return;
    var views = document.querySelectorAll('[id="recent-viewed"]');
    if (views.length < 2 || views[0] === band) {
      watchClear(st, band);
      return;
    }
    band.removeAttribute('id');
    var grid = band.querySelector('[id="recent-grid"]');
    if (grid) grid.removeAttribute('id');
    var hint = band.querySelector('[data-wh-more-recent-hint]');
    if (WH.design && hint) {
      hint.textContent = 'La section « Wise — Fiche produit » affiche déjà les pièces récemment consultées : décochez son réglage « Afficher les pièces récemment consultées » pour les montrer ici, ou masquez ce bloc.';
    } else {
      band.hidden = true;
    }
  }

  /* « Effacer l'historique » : wise.js (son propre écouteur sur le bouton) masque #recent-viewed.
     Le bouton disparaît avec la bande : on annonce l'effacement et le focus passe au titre de la
     bande visible suivante (sinon de la précédente) au lieu de retomber sur la page. */
  function watchClear(st, band) {
    listen(st, band, 'click', function (e) {
      if (!up(e.target, '[data-recent-clear]')) return;
      window.setTimeout(function () {
        if (!band.hidden) return;
        announce('Historique effacé');
        var active = document.activeElement;
        if (active && active !== document.body && !band.contains(active)) return;
        var h = nearTitle(band, 'nextElementSibling') || nearTitle(band, 'previousElementSibling');
        if (!h) return;
        if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
        focusEl(h);
      }, 0);
    });
  }

  function nearTitle(band, dir) {
    var el = band[dir];
    while (el && (el.hidden || !el.hasAttribute('data-wh-more-band'))) el = el[dir];
    return el ? el.querySelector('h2') : null;
  }

  /* ---------- 5. Une question ? ---------- */
  function initHelp(st) {
    var rows = WH.all('[data-wh-more-guide]', st.root);
    if (!rows.length) return;
    var guide = document.getElementById('size-guide');
    /* wise.js n'ouvre ce guide que sur une fiche [data-product] qui contient #size-guide */
    var ok = !!(guide && document.querySelector('[data-product]'));
    rows.forEach(function (row) {
      var btn = row.querySelector('[data-guide-open]');
      var link = row.querySelector('[data-wh-more-guide-link]');
      if (!btn || !link) return;
      btn.hidden = !ok;
      link.hidden = ok;
    });
    if (!ok || typeof window.MutationObserver !== 'function') return;

    /* wise.js ouvre le guide ; ici, seulement le retour du focus sur notre bouton à la fermeture */
    var opener = null;
    var wasOn = guide.classList.contains('is-on');
    listen(st, st.root, 'click', function (e) {
      var btn = up(e.target, '[data-wh-more-guide] [data-guide-open]');
      if (!btn) return;
      opener = btn;
      window.setTimeout(function () {
        if (!guide.classList.contains('is-on')) opener = null;
      }, 0);
    });
    var mo = new window.MutationObserver(function () {
      var on = guide.classList.contains('is-on');
      if (on === wasOn) return;
      wasOn = on;
      if (!on && opener) {
        var back = opener;
        opener = null;
        if (back.isConnected) focusEl(back);
      }
    });
    mo.observe(guide, { attributes: true, attributeFilter: ['class'] });
    st.offs.push(function () {
      mo.disconnect();
    });
  }

  WH.ready(function (scope) {
    WH.all('[data-wh-more]', scope).forEach(init);
  });

  WH.unload(function (section) {
    WH.all('[data-wh-more]', section).forEach(destroy);
  });
})();
